<!-- ./components/ModalLeadButton.vue -->
<template>
  <div class="lead-modal">
    <button
        type="button"
        :class="btnClass"
        @click="open = true"
    >
      {{ btnText }}
    </button>

    <teleport to="body">
      <div v-if="open" class="lead-modal__overlay" @click="closeModal">
        <div class="lead-modal__panel" role="dialog" aria-modal="true" @click.stop>
          <button
              class="lead-modal__close"
              type="button"
              @click="closeModal"
              aria-label="Закрыть"
          >
            ✕
          </button>

          <div class="lead-modal__title">Заявка</div>

          <div class="lead-modal__subtitle">
            <!--            Страница: <span class="lead-modal__meta">{{ pageName }}</span><br>-->
            <!--            Источник: <a class="lead-modal__link" :href="pageUrl" target="_blank" rel="noopener">{{ pageUrl }}</a>-->
          </div>

          <form class="lead-modal__form" @submit.prevent="submit">
            <div class="lead-modal__field">
              <label class="lead-modal__label">Имя</label>
              <input
                  class="lead-modal__input"
                  type="text"
                  v-model.trim="name"
                  autocomplete="name"
                  placeholder="Как к вам обращаться"
                  :disabled="loading"
              >
            </div>

            <div class="lead-modal__field">
              <label class="lead-modal__label">Телефон</label>
              <input
                  class="lead-modal__input"
                  type="tel"
                  v-model.trim="phone"
                  autocomplete="tel"
                  placeholder="+7..."
                  required
                  :disabled="loading"
              >
            </div>

            <div class="lead-modal__actions">
              <button
                  class="lead-modal__submit"
                  type="submit"
                  :disabled="loading"
              >
                <span v-if="!loading">Отправить</span>
                <span v-else>...</span>
              </button>

              <button
                  class="lead-modal__cancel"
                  type="button"
                  @click="closeModal"
                  :disabled="loading"
              >
                Отмена
              </button>
            </div>

            <div v-if="errorText" class="lead-modal__error">
              {{ errorText }}
            </div>

            <div v-if="success" class="lead-modal__success">
              ✔ Отправлено
            </div>
          </form>
        </div>
      </div>
    </teleport>
  </div>
</template>

<script>
export default {
  name: 'ModalLeadButton',

  props: {
    btnText: { type: String, default: 'Оставить заявку' },
    btnClass: { type: String, default: 'btn-main' },
    endpoint: { type: String, default: '/send-app.php' },

    pageName: { type: String, default: '' },
    pageUrl: { type: String, default: '' }
  },

  data() {
    return {
      open: false,
      name: '',
      phone: '',
      loading: false,
      success: false,
      errorText: ''
    };
  },

  methods: {
    closeModal() {
      if (this.loading) {
        return;
      }

      this.open = false;
      this.success = false;
      this.errorText = '';
    },

    resetForm() {
      this.name = '';
      this.phone = '';
      this.loading = false;
      this.success = false;
      this.errorText = '';
    },

    async submit() {
      if (!this.name || !this.phone) {
        this.errorText = 'Пожалуйста, заполните все поля.';
        return;
      }

      this.errorText = '';
      this.loading = true;

      try {
        const fd = new FormData();
        fd.append('formName', this.name);
        fd.append('formPhone', this.phone);
        fd.append('pageName', this.pageName);
        fd.append('pageUrl', this.pageUrl);

        const res = await fetch(this.endpoint, {
          method: 'POST',
          body: fd
        });

        if (!res.ok) {
          throw new Error();
        }

        await res.text();

        this.success = true;

        setTimeout(() => {
          this.open = false;
          this.resetForm();
        }, 800);
      } catch (e) {
        this.errorText = 'Произошла ошибка при отправке формы. Попробуйте снова.';
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>